export default "__VITE_ASSET__16d42fb5__"